enum AIReviewStatus {
    PENDING = "pending",
    COMPLETED = "completed",
    IN_PROGRESS = "in_progress",
    PARTIALLY_COMPLETED = "partially_completed",
    FAILED = "failed",
    CANCELLED = "canceled"
}

export const AIReviewStatusLabel = {
    [AIReviewStatus.PENDING]: "Pending AI review",
    [AIReviewStatus.COMPLETED]: "AI reviewed",
    [AIReviewStatus.IN_PROGRESS]: "AI review in progress",
    [AIReviewStatus.PARTIALLY_COMPLETED]: "Partially AI reviewed",
    [AIReviewStatus.FAILED]: "AI review failed",
    [AIReviewStatus.CANCELLED]: "AI review cancelled"
};

export const AIReviewStatusIndicatorColor = {
    [AIReviewStatus.PENDING]: "var(--marker-yellow)",
    [AIReviewStatus.COMPLETED]: "var(--marker-blue)",
    [AIReviewStatus.IN_PROGRESS]: "var(--marker-orange)",
    [AIReviewStatus.PARTIALLY_COMPLETED]: "var(--marker-green)",
    [AIReviewStatus.FAILED]: "var(--marker-peach)",
    [AIReviewStatus.CANCELLED]: "var(--marker-peach)"
};

export default AIReviewStatus;
